// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateStatusChangeRequestObject = (name, data) => ({
    data,
    name,
    type: actions.UPDATE_STATUS_CHANGE_REQUEST_OBJECT
});



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/update-status-change-request-object.js